<!-- 
  列表页底部组件
  emit: 
    deleteArr: 提交批量删除请求
 -->

<template>
	<div class="list-footer" v-clickoutside="hideList" v-show="permission.length">
    <div class="foot-bg">
      <div class="selected" @click="showListHandle">
        已选<strong>{{getSelectIds.length}}</strong>条
      </div>
      <ul class="foot-menu">
        <li class="tit">批量</li>
        <li class="item" v-for="item in permission">
          <el-button
            size="small"
            v-if="['archiveBatch', 'del', 'batchEdit', 'batchPrint'].indexOf(item) > -1"
            :class="{'red': item === 'del' || item === 'archiveBatch'}"
            @click="handlePerm(item)">
            <template v-if="archived === 1 && item === 'archiveBatch'">取消</template>{{bottomMap[item]}}
          </el-button>
          <slot v-else name="permission" :type="item" :text="bottomMap[item]">
          </slot>
        </li>
      </ul>
    </div>
    <!-- 已选客户 -->
    <transition name="fold">
      <div class="select-list" v-show="showList">
        <div class="list-head">
          <h4 class="list-tit">已选{{currentName}} ({{getSelectIds.length}})</h4>
          <i class="close el-icon-close" @click="showList=false"></i>
        </div>
        <div class="list-con">
          <ul>
            <li class="item" v-for="(key, value) in getSelectRows">
              <span class="text">{{key}}</span>
              <i class="close el-icon-circle-close" @click="removeItem(value)"></i>
            </li>
          </ul>
        </div>
      </div>
    </transition>

    <!-- <Print v-if="choosePrintType" 
    :entityId="id"
    :moduleName="moduleName"
    :templateId="templateMsg.templateId" 
    :refType="templateMsg.refType"
    @closeDialog="closePrint"
    >
    </Print> -->
	</div>
</template>

<script>
import * as common from 'src/config/common-config'
import { mapGetters, mapActions } from 'vuex'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
// import batchPrintMixin from 'src/config/batchPrintMixin' // 批量打印
export default {
  // mixins: [batchPrintMixin],
  props: {
    permission: {
      type: Array,
      default: []
    },
    // 归档状态
    archived: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showList: false,
      moduleMap: common.moduleMap,
      bottomMap: common.bottomMap
    }
  },
  computed: {
    ...mapGetters([
      'getSelectRows',
      'getSelectIds',
      'getSelectPu',
      'moduleName'
    ]),
    // 当前模块名
    currentName () {
      return this.moduleMap[this.moduleName]
    }
  },
  methods: {
    ...mapActions([
      'updateSelectrows'
    ]),
    handlePerm (type) {
      switch (type) {
        case 'del':
          this.handleDelete()
          break
        case 'archiveBatch':
          this.handleArchived('archiveBatch')
          break
        case 'batchEdit':
          this.handleArchived('batchEdit')
          break
        case 'batchPrint':
          this.handleArchived('batchPrint')
          break
        default:
          console.warn(type)
      }
    },
    // 删除
    handleDelete () {
      this.$emit('deleteArr')
    },
    // 批量归档,编辑,打印
    handleArchived (type) {
      this.$emit('archived', type)
    },
    // 取消选中
    removeItem (id) {
      // 同步到vuex
      this.updateSelectrows({del: id})
      this.$emit('cancelCheck', id)

      // 当选中数量为0时，关掉弹窗
      if (!this.getSelectIds.length) {
        this.hideList()
      }
    },
    // 显示已选客户列表
    showListHandle () {
      if (this.getSelectIds.length) {
        this.showList = !this.showList
      }
    },
    hideList () {
      this.showList = false
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .list-footer{
    position: relative;
    font-size: 0;
    z-index: 10;
    float: left;
    .foot-bg {
      background-color: #fff;
      padding: 3px 0;
      display: flex;
      flex-wrap: nowrap;
    .selected {
      background-color: #fff;
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      padding-right: 20px;
      border-right: 1px solid #d9d9d9;
      line-height: 24px;
      height: 24px;
      cursor: pointer;
      white-space: nowrap;
      strong {
        font-weight: 600;
        font-size: 15px;
        margin: 0 5px;
      }
      &:hover {
        color: @bg-red;
      }
    }
    .foot-menu {
      display: inline-block;
      margin-left: 20px;
      display: flex;
      flex-wrap: nowrap;
      .tit {
        font-size: 13px;
        display: inline-block;
        margin-right: 10px;
        line-height: 24px;
      }
      .item {
        display: inline-block;
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
        .el-button {
          padding-top: 5px;
          padding-bottom: 5px;
          color: #666;
          &:hover {
            color: @primary;
          }
          &.red {
            color: @bg-red;
            &:hover {
              border-color: @bg-red;
            }
          }
        }
      }
    }
    }
    .select-list {
      position: absolute;
      left: 0;
      top: -15px;
      width: 360px;
      box-shadow: 0 0 4px 0 rgba(105, 105, 105, 0.5);
      border-radius: 0 0 2px 2px;
      overflow: hidden;
      z-index: -1;
      transform: translate3d(0, -100%, 0);
      &.fold-enter-active, &.fold-leave-active {
        transition: all 0.3s ease-out;        
      }
      &.fold-enter,&.fold-leave-active {
        transform: translate3d(0, 0, 0);
      }
      .list-head {
        background-color: @dark-blue;
        color: #fff;
        padding: 15px;
        border-radius: 2px 2px 0 0;
        position: relative;
        .list-tit {
          font-size: 16px;
          line-height: 1;
        }
        .close {
          position: absolute;
          right: 15px;
          top: 14px;
          font-size: 18px;
          cursor: pointer;
        }
      }
      .list-con {
        padding: 10px;
        background-color: #fff;
        max-height: 500px;
        overflow: auto;
        .item {
          padding: 15px 8px;
          border-bottom: 1px dashed #d8d8d8;
          position: relative;
          &:last-child {
            border-bottom-width: 0;
          }
          .text {
            font-size: 13px;
            line-height: 1;
            color: #666;
            display: block;
            margin-right: 24px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .close {
            position: absolute;
            padding: 5px;
            right: 2px;
            top: 9px;
            line-height: 1;
            font-size: 16px;
            color: #ff6161;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// list-footer.vue?05d7df36